import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { FormattedMessage, intlShape } from "react-intl";

import { TextInput } from "../../../common/form";

import validationUtils from "../../../../utils/ValidationUtils";
import { MESSAGES_VALIDATION_RULES } from "./messagesValidationRules";

class BasicMessageFields extends React.Component {
  getChildContext() {
    return {
      scene: this.props.scene,
    };
  }

  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <Field
          id="message"
          name="message"
          className="message"
          component={TextInput}
          required={true}
          componentClass="textarea"
          disabled={this.props.initialValues.disabled}
          type="textarea"
          label={<FormattedMessage id="messages.form.message" />}
        />
      </form>
    );
  }
}

BasicMessageFields.propTypes = {
  scene: PropTypes.string,
  validation: PropTypes.object,
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
};

BasicMessageFields.defaultProps = {
  scene: "",
};

BasicMessageFields.contextTypes = {
  getData: PropTypes.func,
  intl: intlShape,
};

BasicMessageFields.childContextTypes = {
  scene: PropTypes.string,
};

export default connect(null, null, null, { withRef: true })(
  reduxForm({
    form: "message",
    validate: (values) =>
      validationUtils.validate(values, MESSAGES_VALIDATION_RULES),
  })(BasicMessageFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/follow-ups/messages/BasicMessageFields.js